var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,1C11.767,1,1,11.767,1,25s10.767,24,24,24s24-10.767,24-24S38.233,1,25,1z M25,47C12.869,47,3,37.131,3,25 S12.869,3,25,3s22,9.869,22,22S37.131,47,25,47z",
    id: "id_106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,23.277V7h-2v16.277c-0.595,0.346-1,0.984-1,1.723c0,0.178,0.031,0.347,0.074,0.512l-8.781,8.781l1.414,1.414 l8.781-8.781C24.653,26.969,24.822,27,25,27c1.104,0,2-0.895,2-2C27,24.262,26.595,23.624,26,23.277z",
    id: "id_107"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.2c1f1ced4c633404173dbde1f281dbab.svg";
export { ForwardRef as ReactComponent };